import art from "./splash-art.json";

export type DemoBrand = "echoplay" | "sunny-sandy";

// Change this one value to switch BOTH the splash and the demo-scan cheat button.
// EchoPlay has no splash logo; its cheat button still uses eplogo.png.
// No command-line, environment, or URL parameter is needed. Rebuild for production.
export const DEMO_BRAND: DemoBrand = "echoplay";

export const DEMO_BRANDS = {
  echoplay: {
    name: "EchoPlay",
    logo: "/api/resource/eplogo.png",
    splashLogo: null,
    splashWidth: 256,
    splashHeight: 256,
  },
  "sunny-sandy": {
    name: "Sunny & Sandy",
    logo: "/api/resource/sslogo.png",
    splashLogo: art.logo,
    splashWidth: 246,
    splashHeight: 89,
  },
} as const;

export const demoBrand = DEMO_BRANDS[DEMO_BRAND];
